import { defineStore } from 'pinia';
export const useImageHashStore = defineStore('imageHashStore', {
    state: () => ({
        images: {},
    }),
});
